var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextLetter = function SvgTextLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M4 4.667C4 4.298 4.298 4 4.667 4h6.666c.368 0 .667.298.667.667V6a.667.667 0 0 1-1.333 0v-.667h-2v5.334h.666a.667.667 0 1 1 0 1.333H6.667a.667.667 0 0 1 0-1.333h.666V5.333h-2V6A.667.667 0 1 1 4 6V4.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgTextLetter;